import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { Restock } from '../model/restock-new.interface';

@Injectable()
export class RestockNewService {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    PostValidateRestock(request: Restock[]): Observable<RequestResponse<any>> {
        return this._httpClient.post<RequestResponse<any>>(this._urlBase + 'api/Restock/RestockValidate', request);
    }

    PostRestock(request: Restock[]): Observable<RequestResponse<any>> {
        return this._httpClient.post<RequestResponse<any>>(this._urlBase + 'api/Restock/RestockInsert', request);
    }

}
